<app-periodo-dashboard #periodo [periodoInicial]="periodoInicial" prefijo="proyectos" (cambio)="onPeriodo($event)">
  <div meta class="tickets-toolbar__meta">
    <span>{{ totalProyectos }} proyectos</span>
    <strong>Foto de hoy &middot; creados por mes: {{ periodo.etiqueta }}</strong>
  </div>
</app-periodo-dashboard>

<div class="tickets-alert" *ngIf="errorCarga">
  {{ errorCarga }}
</div>

<section class="tickets-kpis tickets-kpis--proyectos" aria-label="Indicadores principales de proyectos">
  <article class="ticket-kpi" *ngFor="let kpi of kpis" [ngClass]="kpi.className">
    <div class="ticket-kpi__icon">
      <mat-icon>{{ kpi.icon }}</mat-icon>
    </div>
    <div>
      <span>{{ kpi.label }}</span>
      <strong>{{ kpi.value }}</strong>
      <small>{{ kpi.meta }}</small>
    </div>
  </article>

  <div class="tickets-loading-card" *ngIf="cargando && kpis.length === 0">
    Actualizando indicadores...
  </div>
</section>

<section class="tickets-grid">
  <article class="tickets-card tickets-card--status">
    <div class="tickets-card__header">
      <div>
        <span>Cartera</span>
        <h2>Proyectos por estatus</h2>
      </div>
    </div>

    <div class="tickets-status">
      <div class="tickets-donut" [ngStyle]="getDonutStyle()">
        <div class="tickets-donut__center">
          <strong>{{ totalProyectos }}</strong>
          <span>Total</span>
        </div>
      </div>

      <div class="tickets-status__legend">
        <div class="tickets-status__item" *ngFor="let item of estatusItems">
          <span class="tickets-status__dot" [style.background]="item.color"></span>
          <span>{{ item.nombre }}</span>
          <strong>{{ item.valor }}</strong>
        </div>
      </div>
    </div>

    <div class="tickets-empty" *ngIf="!cargando && estatusItems.length === 0">
      No hay proyectos para mostrar.
    </div>
  </article>

  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Clientes</span>
        <h2>Proyectos activos por cliente</h2>
      </div>
    </div>

    <div class="tickets-bars" *ngIf="clienteItems.length > 0; else emptyClientesTpl">
      <div class="tickets-bar" *ngFor="let item of clienteItems; let i = index">
        <div class="tickets-bar__row">
          <span>{{ item.nombre || 'Sin cliente' }}</span>
          <strong>{{ getBarPercent(item, activos) }}%</strong>
        </div>
        <div class="tickets-bar__track">
          <span [ngStyle]="getBarStyle(item, i, activos)"></span>
        </div>
        <small>{{ item.valor }} activos</small>
      </div>
    </div>
  </article>
</section>

<section class="tickets-grid tickets-grid--secondary">
  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Tendencia</span>
        <h2>Proyectos creados por mes</h2>
      </div>
    </div>

    <div class="incident-months" *ngIf="mesItems.length > 0; else emptyMesesTpl">
      <div class="incident-month" *ngFor="let item of mesItems; let i = index">
        <span>{{ item.nombre }}</span>
        <div class="incident-month__bar">
          <span [ngStyle]="getBarStyle(item, i, mesMax)"></span>
        </div>
        <strong>{{ item.valor }}</strong>
      </div>
    </div>
  </article>

  <article class="tickets-card">
    <div class="tickets-card__header">
      <div>
        <span>Riesgos</span>
        <h2>Riesgos abiertos por severidad</h2>
      </div>
    </div>

    <div class="tickets-bars" *ngIf="severidadItems.length > 0; else emptyRiesgosTpl">
      <div class="tickets-bar" *ngFor="let item of severidadItems; let i = index">
        <div class="tickets-bar__row">
          <span>{{ item.nombre || 'Sin severidad' }}</span>
          <strong>{{ getBarPercent(item, totalRiesgos) }}%</strong>
        </div>
        <div class="tickets-bar__track">
          <span [ngStyle]="getBarStyle(item, i, totalRiesgos)"></span>
        </div>
        <small>{{ item.valor }} riesgos</small>
      </div>
    </div>
  </article>
</section>

<section class="tickets-card tickets-card--table">
  <div class="tickets-card__header">
    <div>
      <span>Seguimiento</span>
      <h2>Proyectos con mayor desviacion</h2>
    </div>
    <button type="button" class="tickets-link-button" *ngIf="canViewGestion" (click)="abrirGestion()">Ver todos</button>
  </div>

  <div class="tickets-area-list" *ngIf="desviaciones.length > 0; else emptyDesviacionTpl">
    <div class="tickets-area proyectos-desviacion" *ngFor="let item of desviaciones; let i = index"
      [class.proyectos-desviacion--abrible]="canViewSeguimiento" (click)="abrirDetalle(item)" (keydown.enter)="abrirDetalle(item)">
      <span class="tickets-area__rank">{{ i + 1 }}</span>
      <div>
        <strong>{{ item.nombre || item.idProyecto || 'Sin nombre' }}</strong>
        <small>{{ item.cliente || 'Sin cliente' }} &middot; real {{ item.avanceReal }}% / planeado {{ item.avancePlaneado }}%</small>
      </div>
      <span class="tickets-area__percent proyectos-desviacion__delta" [ngClass]="getDesviacionClass(item)">
        {{ getDesviacionLabel(item) }}
      </span>
    </div>
  </div>
</section>

<ng-template #emptyClientesTpl>
  <div class="tickets-empty">No hay proyectos activos con cliente.</div>
</ng-template>

<ng-template #emptyMesesTpl>
  <div class="tickets-empty">No se crearon proyectos en el periodo.</div>
</ng-template>

<ng-template #emptyRiesgosTpl>
  <div class="tickets-empty">No hay riesgos abiertos en los proyectos activos.</div>
</ng-template>

<ng-template #emptyDesviacionTpl>
  <div class="tickets-empty">No hay proyectos activos para comparar.</div>
</ng-template>
